module.exports = __webpack_public_path__ + "img/add-to-apple-wallet.466d331a.png";